export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8344.a2e3b56e.jpg";